/*
  ImportSection.jsx
*/

// Npm.
import React, { useState, useEffect } from 'react';

// Lib.
import botechToGraphData from '../../../utils/botechToGraphData';
import readBlobAsText from '../../../utils/readBlobAsText';

// Components.
import BottomActions from './BottomActions';
import CodeField from '../../CodeField';
import Button from '../../Button';
import ButtonWithFileInput from '../../ButtonWithFileInput';

// Hooks.
import useSetPromise from '../../../hooks/useSetPromise';

// Constants.
const MAX_FILE_SIZE = 67108864;  // ~ 64 MB.

/**
 * Section for importing a model.
 */
export default function ImportSection({
  className,
  onChangeGraphData,
  onClose,
  ...rest
}) {

  const [importText, setImportText] = useState('');
  const [errorText, setErrorText] = useState('');

  // File reading promise state.

  const [importPromise, setImportPromise] = useSetPromise((err, text) => {
    if (err) {
      setErrorText(err.message);
    } else {
      setImportText(text);
    }
  });

  // Handlers.

  function handleChangeImportText(event) {
    setImportText(event.target.value);
    setErrorText('');
  }

  function handleChangeFile(event) {
    const file = event.target.files?.[0];
    if (file && file.size > 0 && file.size <= MAX_FILE_SIZE) {
      setImportPromise(readBlobAsText(file));
      setErrorText('');
    }
  }

  function handleClickLoad() {
    try {
      if (onChangeGraphData) {
        onChangeGraphData(botechToGraphData(JSON.parse(importText)));
      }
      if (onClose) {
        onClose();
      }
    } catch (err) {
      setErrorText(err.message);
    }
  }

  return (
    <div className={className}>

      <p className="body2 gutterBottom">{ errorText || 'Import a model:' }</p>
 
      <div>
        <CodeField
          value={importText}
          onChange={handleChangeImportText}
          placeholder="Copy / Paste in Model"
          maxLength={MAX_FILE_SIZE}
        />
      </div>

      <BottomActions>
        <ButtonWithFileInput
          onChange={handleChangeFile}
          type="file"
          accept="application/json,text/plain"
          disabled={importPromise != null}
        >
          Import from File
        </ButtonWithFileInput>
        <Button onClick={handleClickLoad} disabled={importText.length === 0}>
          Load Model
        </Button>
      </BottomActions>

    </div>
  );
}
